import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { checkIsArchive } from 'Utils'
import { openListingTermsConditionModal } from 'Modules/modals/actions'
import SvgIcon from 'Components/SvgIcon'
import ImagePlaceholder, { COMING_SOON_IMAGE } from 'Components/ImagePlaceholder'
import WithWindowSize from 'Components/WithWindowSize'
import { MODAL_TYPE, SL_GATE } from 'Defaults/modals'
import { FAVOURITE_TYPES } from 'Defaults/favourites'
import { LoginModal } from 'Layout/Modals/containers'
import { createListingPhotoUrlList } from 'Utils/photoUtils'
import { PhotosAndLocationModal } from 'Layout'
import { photoLocationMenus } from 'Layout/PhotosAndLocationModal/components/PhotosAndLocationMenu'
import FavouriteToast from 'Components/Favourites/FavouriteToast'
import { ImageSlider } from 'Components/ListingPreview/components'
import OpenHouseBanner from 'Components/OpenHouseBanner'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'

import {
  PlaceHolderRow,
  ListingLockCard,
  VerifyEmailCard,
  ListingTermsUseContainer,
} from './components'

import TopBannerMobile from './components/TopBannerMobile'

import {
  _DesktopDisclaimerNotification,
  _MobileDisclaimerNotification,
  _Section,
  _ImageContainer,
  _LeftImageCol,
  _RightImageCol,
  _PhotoGridWrap,
  _PhotoGridHolder,
  _OverlayCtaContainer,
  _ImageCounter,
  _VT,
  _TagBlock,
} from './styles.js'


const LOCKED_LISTING_CARD = 'Locked Listing Card'
const PAGE_TYPE = 'Listing'

class ListingHero extends Component {
  constructor(props) {
    super(props)
    // this.getLinkButtons = this.getLinkButtons.bind(this)

    const urlList = createListingPhotoUrlList(props.listing)
    this.state = {
      urlList,
      showFreeSignup: false,
      clientSideIsMounted: false,
    }
    this.favHandler = this.favHandler.bind(this)

    this.updateUrlList = this.updateUrlList.bind(this)
    this.renderPhotoGrid = this.renderPhotoGrid.bind(this)
    this.updateLoginCardVisibility = this.updateLoginCardVisibility.bind(this)
  }

  componentDidMount() {
    this.updateLoginCardVisibility()
    this.setState({ clientSideIsMounted: true })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.listing !== this.props.listing) {
      this.updateUrlList(this.props.listing)
    }

    this.updateLoginCardVisibility()
  }

  updateLoginCardVisibility() {
    const shouldCardBeVisible = !this.props.userIsAuthentificated &&
      !this.props.featured &&
      ![MODAL_TYPE.LOGIN, MODAL_TYPE.REGISTER].includes(this.props.modalType)

    if(shouldCardBeVisible !== this.state.showFreeSignup) {
      this.setState({ showFreeSignup: !this.state.showFreeSignup })
    }
  }

  handleUnauthenticatedUser = () => {
    const { openModal } = this.props
    openModal({
      modalType: MODAL_TYPE.LOGIN,
      modalSource: 'fav button',
      modalData: { gate: SL_GATE.FAVOURITE },
    })
  }

  showFavouriteToast = (modelType, source) => {
    toast.success(
      <FavouriteToast
        openEditFavouritesModal={() => this.showEditFavouritesModal(modelType, source)}
      />,
      {
        position: 'bottom-center',
        autoClose: 8000,
        className: 'favouritesToast',
        closeButton: false,
      },
    )
  }

  showEditFavouritesModal = (modelType, source) => {
    const {
      listing,
      openModal,
      userFavListings,
      isArchived,
    } = this.props

    const favouriteTagsNote = userFavListings ? userFavListings[listing.mls_number] : {}

    openModal({
      modalType: MODAL_TYPE.EDIT_FAVOURITES,
      modalData: {
        modelType,
        modelId: listing.id,
        mlsNumber: listing.mls_number,
        existingTags: favouriteTagsNote?.tags,
        existingNote: favouriteTagsNote?.note,
        homeType: listing.home_type,
        propertyClass: listing.property_class,
        isArchived,
        offerType: listing.offer,
        gaSource: source,
      },
      modalSource: PAGE_TYPE,
    })
  }

  handleFavouriteGA = (source) => {
    const {
      listing,
      favourited,
      googleAnalyticsEvent,
      isArchived,
    } = this.props
    const listingType = `${listing.offer?.toLowerCase()} ${isArchived ? 'archive' : 'active'}`

    googleAnalyticsEvent({
      category: PAGE_TYPE,
      action: [
        'Favourite Click',
        `${favourited ? 'Remove' : 'Add'}`,
        ...(source ? [source] : []),
        listingType,
      ],
    })
  }

  handleToggle = (source) => {
    const {
      listing,
      toggleFavListing,
      isArchived,
    } = this.props
    const modelType = isArchived
      ? FAVOURITE_TYPES.ARCHIVE_LISTING
      : FAVOURITE_TYPES.LISTING
    toggleFavListing(listing.id, listing.mls_number, modelType)
    this.handleFavouriteGA(source)
  }

  handleAuthenticatedUser = (source) => {
    const {
      favourited,
      openModal,
      isArchived,
      userFavListings,
      listing,
    } = this.props

    const modelType = isArchived
      ? FAVOURITE_TYPES.ARCHIVE_LISTING
      : FAVOURITE_TYPES.LISTING


    if(!favourited) {
      this.handleToggle(source)
      this.showFavouriteToast(modelType, source)
    } else {
      const favouriteTagsNote = userFavListings ? userFavListings[listing.mls_number] : {}
      const tagsNoteExist =
        (favouriteTagsNote?.note && favouriteTagsNote?.note.trim() !== '') || favouriteTagsNote?.tags?.length > 0

      openModal({
        modalType: MODAL_TYPE.FAVOURITES_OPTIONS,
        modalData: {
          handleToggle: () => this.handleToggle(source),
          handleOpenEditModal: () => this.showEditFavouritesModal(modelType, source),
          tagsNoteExist,
        },
        modalSource: PAGE_TYPE,
      })
    }
  }

  favHandler = (source) => {
    const {
      userIsAuthentificated,
      listing,
    } = this.props

    if(!listing) return null

    if(!userIsAuthentificated) {
      this.handleUnauthenticatedUser()
    } else {
      this.handleAuthenticatedUser(source)
    }
  }

  updateUrlList(listing) {
    if(listing) {
      const urlList = createListingPhotoUrlList(listing)
      this.setState({ urlList })
    }
  }

  renderPhotoGrid = (listing, showFreeSignup) => {
    const { title, id, mls_number: mlsNumber,
      tourUrl, status, photo_count: photoCount, source,
    } = listing || {}
    const isArchived = checkIsArchive(status)
    if(this.props.photoHidden) {
      return <PlaceHolderRow />
    }
    const { urlList } = this.state

    let firstMobImgSrc = COMING_SOON_IMAGE
    let secondMobImgSrc = COMING_SOON_IMAGE
    let thirdMobImgSrc = COMING_SOON_IMAGE

    if(urlList.length > 0) {
      firstMobImgSrc = showFreeSignup ? urlList[0].lowQualityImgPath : urlList[0].img
      if(urlList.length > 1) {
        secondMobImgSrc = showFreeSignup ? urlList[1].lowQualityImgPath : urlList[1].img
      }
      if(urlList.length > 2) {
        thirdMobImgSrc = showFreeSignup ? urlList[2].lowQualityImgPath : urlList[2].img
      }
    }
    const width = 640
    const height = 480
    if(this.props.isMobileApp) {
      return (
        <ImageSlider
          id={id}
          isArchived={isArchived}
          photoCount={photoCount}
          title={title}
          mlsNumber={mlsNumber}
          hideCounterVT
          showSlider
          source={source}
          mobileBrowser
          openSignup={() => {}}
          userIsLoggedIn={this.props.userIsAuthentificated}
          noLoginRequired={this.props.featured}
          dataSource={'heroImage'}
          hasMyAgent={this.props.hasMyAgent}
          setImageViewedListing={() => {
            this.props.googleAnalyticsEvent({
              category: 'Listing Hero Img Slider',
              action: '[Next Image Swiped]',
            })
          }}
          tourUrl={tourUrl}
          openPhotosAndLocation={this.props.openPhotosAndLocation}
          listing={listing}
        />

      )
    }

    return (
      <_ImageContainer
        key={firstMobImgSrc}
      >
        <Helmet>
          <link rel="preload" as="image" href={firstMobImgSrc} />
        </Helmet>

        <_LeftImageCol onClick={() => this.props.openPhotosAndLocation()}>
          <ImagePlaceholder src={firstMobImgSrc} alt={title} noLazy width={width} height={height} />
        </_LeftImageCol>
        <_RightImageCol onClick={() => this.props.openPhotosAndLocation()}>

          <ImagePlaceholder src={secondMobImgSrc} alt={title} width={width} height={height} />
          <ImagePlaceholder src={thirdMobImgSrc} alt={title} width={width} height={height} />
        </_RightImageCol>
      </_ImageContainer>
    )
  }

  renderDisclaimerNotifications(notifications) {
    if(!notifications) return ''
    return (
      <p>
        {notifications.map(item => `${item.message} `)}
      </p>
    )
  }

  render() {
    const {
      listingIsLocked,
      listing,
      favourited,
      isArchived,
      openModal,
      isAddressPage = false,
      requiredEmailVerification,
      openEmailVerifyModal,
      featured,
      userIsAuthentificated,
      googleAnalyticsEvent,
      requireTermsConditionAgreement,
      termsConditionRequiredId,
      handleBookViewing,
      agent,
      handleContactAgentClick,
      lastPathStack,
      isMobileApp,
      hasAnyHiddenFields,
      userIsAdmin,
      userIsAgentSupport,
      userIsAgent,
      closePhotosAndLocation,
      isPhotosAndLocationOpen,
      photosAndLocationModalMode,
      onShareClick,
      closeModalListing,
      openHouses,
      isPrecon,
    } = this.props
    const { urlList, showFreeSignup } = this.state

    const title = (listing && listing.title) || 'ListingPage'

    const photoCount = listing?.photo_count
    const tourUrl = listing?.tour_url

    const blurContent =
      listingIsLocked ||
      requiredEmailVerification ||
      requireTermsConditionAgreement

    const blurPhotoGrid = blurContent || (!userIsAuthentificated && !featured)
    return (
      <Fragment>
        {
          listing?.notifications ?
            <_DesktopDisclaimerNotification>
              {this.renderDisclaimerNotifications(listing.notifications)}
            </_DesktopDisclaimerNotification>
            : ''
        }
        <TopBannerMobile
          listing={listing}
          lastPathStack={lastPathStack}
          isMobileApp={isMobileApp}
          hasAnyHiddenFields={hasAnyHiddenFields}
          requiredEmailVerification={requiredEmailVerification}
          userIsAdmin={userIsAdmin}
          userIsAgent={userIsAgent}
          userIsAgentSupport={userIsAgentSupport}
          openModal={openModal}
          favourited={favourited}
          favHandler={this.favHandler}
          onShareClick={onShareClick}
          googleAnalyticsEvent={googleAnalyticsEvent}
          closeModalListing={closeModalListing}
          isAddressPage={isAddressPage}
          listingIsLocked={listingIsLocked}
          userIsAuthentificated={userIsAuthentificated}
        />
        {
          listing?.notifications ?
            <_MobileDisclaimerNotification>
              {this.renderDisclaimerNotifications(listing.notifications)}
            </_MobileDisclaimerNotification>
            : ''
        }

        <_Section key={title + this.state.clientSideIsMounted}>
          <OpenHouseBanner openHouses={openHouses}/>
          <_PhotoGridWrap isMobileApp={isMobileApp}>
            <_PhotoGridHolder blured={blurPhotoGrid}>
              {this.renderPhotoGrid(listing, showFreeSignup)}
            </_PhotoGridHolder>
            <>
              {
                isPrecon && <_TagBlock>Pre-construction</_TagBlock>
              }
              <_ImageCounter>
                {
                  photoCount > 3 ?
                    `+${photoCount - 3}`
                    : `1/${photoCount || 1}`
                }
              </_ImageCounter>
              { tourUrl &&
                <_VT>
                  <SvgIcon name={'#icon-virtual-tour'} width={18} height={18} />
                </_VT>
              }
            </>
          </_PhotoGridWrap>


          {requireTermsConditionAgreement && (
            <ListingTermsUseContainer
              openListingTermsConditionModal={openListingTermsConditionModal}
              winWidth={this.props.winWidth}
              listingSource={{
                id: termsConditionRequiredId,
                name: listing?.source,
              }}
            />
          )}
          {showFreeSignup && (
            <_OverlayCtaContainer>
              {this.props.winWidth === null ? null : (
                this.props.winWidth >= 1280 ? (
                  <LoginModal
                    tabId={0}
                    listingCard
                    gate={
                      isAddressPage
                        ? SL_GATE.ADDRESS_HERO_IMAGE
                        : SL_GATE.LISTING_PAGE_HERO_IMAGE
                    }
                    modalSource={LOCKED_LISTING_CARD}
                  />
                ) : (
                  <ListingLockCard
                    openModal={openModal}
                    modalSource={LOCKED_LISTING_CARD}
                  />
                )
              )}
            </_OverlayCtaContainer>
          )}
          {requiredEmailVerification ? (
            <_OverlayCtaContainer>
              <VerifyEmailCard openEmailVerifyModal={openEmailVerifyModal} />
            </_OverlayCtaContainer>
          ) : (
            ''
          )}
          {
            isPhotosAndLocationOpen ?
              <PhotosAndLocationModal
                isPhotosAndLocationOpen={isPhotosAndLocationOpen}
                urlList={urlList}
                closePhotosAndLocation={closePhotosAndLocation}
                listing={listing}
                handleBookViewing={handleBookViewing}
                agent={agent}
                favHandler={this.favHandler}
                onShareClick={() => onShareClick('Pre Gallery')}
                userIsAuthentificated={userIsAuthentificated}
                address={this.props.address}
                openModal={openModal}
                googleAnalyticsEvent={googleAnalyticsEvent}
                isArchived={isArchived}
                handleContactAgentClick={handleContactAgentClick}
                isMapMode={photosAndLocationModalMode === photoLocationMenus.location}
                isMobileApp={isMobileApp}
                places={this.props.places}
                listingIsLocked={blurContent}
                isPrecon={isPrecon}
              />
              : ''
          }
        </_Section>
      </Fragment>
    )
  }
}

const favouriteObjectPropType = PropTypes.shape({
  note: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
})

ListingHero.propTypes = {
  listing: PropTypes.shape({
    photo_count: PropTypes.number,
    photo_base_url: PropTypes.string,
    mls_number: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.number,
    offer: PropTypes.string,
    address: PropTypes.shape({}),
    tour_url: PropTypes.string,
    medias: PropTypes.oneOfType([
      PropTypes.shape({
        Matterport: PropTypes.shape({}),
        MPEmbed: PropTypes.shape({}),
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    source: PropTypes.string,
    notifications: PropTypes.arrayOf(PropTypes.shape({})),
    home_type: PropTypes.string,
    property_class: PropTypes.string,
    open_houses: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  userIsAuthentificated: PropTypes.bool,
  openModal: PropTypes.func,
  listingIsLocked: PropTypes.bool,
  isArchived: PropTypes.bool,
  winWidth: PropTypes.number,
  favourited: PropTypes.bool,
  toggleFavListing: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  modalType: PropTypes.string,
  isAddressPage: PropTypes.bool,
  address: PropTypes.shape({}),
  requiredEmailVerification: PropTypes.bool,
  photoHidden: PropTypes.bool,
  requireTermsConditionAgreement: PropTypes.bool,
  openEmailVerifyModal: PropTypes.func,
  featured: PropTypes.number,
  termsConditionRequiredId: PropTypes.number,
  handleBookViewing: PropTypes.func,
  agent: PropTypes.shape({}),
  handleContactAgentClick: PropTypes.func,
  lastPathStack: PropTypes.arrayOf(PropTypes.string),
  isMobileApp: PropTypes.bool,
  hasAnyHiddenFields: PropTypes.bool,
  userIsAgentSupport: PropTypes.bool,
  openPhotosAndLocation: PropTypes.func,
  closePhotosAndLocation: PropTypes.func,
  isPhotosAndLocationOpen: PropTypes.bool,
  photosAndLocationModalMode: PropTypes.string,
  onShareClick: PropTypes.func,
  closeModalListing: PropTypes.func,
  userIsAgent: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  userFavListings: PropTypes.objectOf(favouriteObjectPropType),
  hasMyAgent: PropTypes.bool,
  places: PropTypes.shape({}),
  openHouses: PropTypes.arrayOf(PropTypes.shape({})),
  isPrecon: PropTypes.bool,
}

export default WithWindowSize(ListingHero)
